export default "__VITE_ASSET__K$XmOm0g__"